import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
interface Testimonial {
  name: string;
  role: string;
  text: string;
}
const testimonials: Testimonial[] = [{
  name: 'Lucas M.',
  role: 'Compró su auto — Villa Lugano, CABA',
  text: 'Estaba en Veraz y no creía que iba a poder comprar un auto. Flash & Go me asesoró, me consiguieron financiación y en dos semanas ya tenía mi Cronos. Increíble el trato.'
}, {
  name: 'Sebastián R.',
  role: 'Conductor Uber — Flores, CABA',
  text: 'Arrancé con el turno de 12 horas para probar y ahora estoy a cargo las 24. Los autos están en perfecto estado y el equipo siempre te da una mano cuando necesitás algo.'
}, {
  name: 'Ezequiel T.',
  role: 'Conductor — Lomas de Zamora, GBA',
  text: 'Lo mejor que hice fue elegir el alquiler con opción a compra. Llevo 9 meses trabajando y en 3 meses más el auto es mío. Sin haber puesto casi nada al principio.'
}, {
  name: 'Marcela F.',
  role: 'Consignación — Caballito, CABA',
  text: 'Dejé mi auto en consignación y en menos de 3 semanas ya estaba vendido. Se encargaron de todo, las fotos, los interesados, el papeleo. Yo no moví un dedo.'
}, {
  name: 'Hernán D.',
  role: 'Inversor — Palermo, CABA',
  text: 'Empecé invirtiendo U$S 15.000 y cobro puntual todos los meses. Es la mejor decisión que tomé para dolarizar mis ahorros. El equipo de Flash & Go es muy serio y transparente.'
}];
function Stars() {
  return <div className="flex gap-0.5 mb-4" aria-label="5 de 5 estrellas" data-id="element-491" data-mp="14uhgkt3ubnv6">
      {Array.from({
      length: 5
    }).map((_, i) => <Star key={i} className="w-4 h-4 text-brand-gold fill-brand-gold" data-id="element-492" data-mp="q4jzex4bvyfh" data-mpi={i} />)}
    </div>;
}
function TestimonialCard({
  t
}: {
  t: Testimonial;
}) {
  return <div className="bg-[#1A1A1A] border-t-2 border-t-brand-gold p-6 rounded-b-lg shadow-lg h-full flex flex-col" data-id="element-493" data-mp="1iu8xp2pnlkde">
      <Stars data-id="element-494" data-mp="1nnlamfkz02qb" />
      <p className="text-brand-white text-sm leading-[1.6] mb-6 flex-grow" data-id="element-495" data-mp="1no3he659dzch">
        “{t.text}”
      </p>
      <div className="mt-auto" data-id="element-496" data-mp="1xfwk6ujbx0zf">
        <p className="text-brand-white font-bold text-[15px]" data-id="element-497" data-mp="1sieav31egjqw">{t.name}</p>
        <p className="text-brand-white/50 text-[13px]" data-id="element-498" data-mp="1sh38n7nlrk1w">{t.role}</p>
      </div>
    </div>;
}
export function Testimonials() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const handleScroll = () => {
    const el = scrollRef.current;
    if (!el) return;
    const cardWidth = el.scrollWidth / testimonials.length;
    setActiveIndex(Math.round(el.scrollLeft / cardWidth));
  };
  const scrollToIndex = (index: number) => {
    const el = scrollRef.current;
    if (!el) return;
    const cardWidth = el.scrollWidth / testimonials.length;
    el.scrollTo({
      left: cardWidth * index,
      behavior: 'smooth'
    });
  };
  return <section className="py-20 bg-brand-black relative" data-id="element-499" data-mp="vuq41h6sgdmn">
      <div className="max-w-7xl mx-auto px-5 sm:px-6" data-id="element-500" data-mp="qulmdnu59cuu">
        {/* Top divider */}
        <div className="h-px w-full bg-gradient-to-r from-transparent via-brand-gold/40 to-transparent mb-16" data-id="element-501" data-mp="32hfffd5h42hh"></div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-502" data-mp="37expj6v88nr2">
          <h2 className="font-heading text-5xl md:text-6xl text-brand-white mb-4" data-id="element-503" data-mp="2jr7en1p8xo4g">
            Lo que dicen nuestros clientes
          </h2>
          <p className="text-brand-gold text-lg font-medium" data-id="element-504" data-mp="2opr3paz4zg11">
            ★★★★★ 4.9 — Cientos de clientes satisfechos en todo el país
          </p>
        </motion.div>

        {/* Desktop grid */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="hidden md:grid grid-cols-2 gap-6" data-id="element-505" data-mp="2xj42uunsndvk">
          {testimonials.map((t, i) => <TestimonialCard key={i} t={t} data-id="element-506" data-mp="1gy28l4c91m3o" data-mpi={i} />)}
        </motion.div>

        {/* Mobile carousel */}
        <div className="md:hidden" data-id="element-507" data-mp="1vn81yboeoi3n">
          <div ref={scrollRef} onScroll={handleScroll} className="flex gap-4 overflow-x-auto snap-x snap-mandatory pb-2 -mx-5 px-5 scrollbar-hide" style={{
          scrollbarWidth: 'none'
        }} data-id="element-508" data-mp="1vo9g4p0pxkpl">
            {testimonials.map((t, i) => <div key={i} className="snap-center shrink-0 w-[85%]" data-id="element-509" data-mp="1zqe8lkffkban" data-mpi={i}>
                <TestimonialCard t={t} data-id="element-510" data-mp="2ek9csd4n5cfi" />
              </div>)}
          </div>

          {/* Dots */}
          <div className="flex justify-center gap-2 mt-6" data-id="element-511" data-mp="29n0r42kaaq9i">
            {testimonials.map((_, i) => <button key={i} onClick={() => scrollToIndex(i)} aria-label={`Ir al testimonio ${i + 1}`} className={`h-2 rounded-full transition-all ${activeIndex === i ? 'w-6 bg-brand-gold' : 'w-2 bg-brand-white/30'}`} data-id="element-512" data-mp="k7t9nl756eev" data-mpi={i} />)}
          </div>
        </div>
      </div>
    </section>;
}